import styled from 'styled-components';
import { themeGet } from '@styled-system/theme-get';
import { Button, Layout } from 'antd';
import { Link } from 'react-router-dom';
import { MOBILE_BREAKPOINT_PX } from '../../../settings/constants';

const { Sider } = Layout;

export const StyledLayout = styled.div`
    width: 100%;
    height: 100vh;
    display: grid;
    @media (min-width: ${MOBILE_BREAKPOINT_PX}) {
        grid-template-columns: 80px 1fr;
    }
    grid-template-columns: 0px 1fr;

    grid-template-rows: 4rem 1fr;
`;

export const StyledHeader = styled.header`
    display: flex;
    padding: 0 24px;
    align-items: center;
    grid-column: 1 / 3;
    border-bottom: ${themeGet('border.standard.color')} solid
        ${themeGet('border.standard.size')};
    &.noauth {
        border: none;
    }
`;
export const StyledLink = styled(Link)`
    line-height: 100%;
`;

export const StyledPageTitle = styled.h1`
    font-size: ${themeGet('font.pageTitle')};
    font-weight: 600;
    margin: 0 24px 0 24px;
`;

export const RightSection = styled.div`
    margin-left: auto;
`;

export const StyledLogoutButton = styled(Button)`
    margin-left: 20px;
`;

export const StyledSider = styled(Sider)`
    height: 100%;
    z-index: 1000;

    @media (min-width: ${MOBILE_BREAKPOINT_PX}) {
        overflow-y: ${({ collapsed, collapsible }) =>
            collapsed && collapsible ? 'clip' : 'auto'};
        overflow-x: clip;
        scrollbar-width: thin;
        ::-webkit-scrollbar {
            width: 4px;
        }

        ::-webkit-scrollbar-track {
            background: #f9f9f9;
            // box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
        }

        ::-webkit-scrollbar-thumb {
            width: 4px;

            background-color: rgba(155, 155, 155, 0.5);
            border-radius: 10px;
            border: transparent;
        }
    }

    overflow-x: visible;
    padding-top: ${themeGet('padding.top')};
    background-color: ${themeGet('color.background')};

    border-right: ${themeGet('border.standard.size')} solid
        ${themeGet('border.standard.color')};

    box-shadow: ${themeGet('boxShadow.card')};
    clip-path: inset(0px -100px 0px 0px);

    .version {
        width: 100%;
        position: absolute;
        bottom: 0px;
        font-size: 10px;
        margin-left: 5px;
        text-indent: 20px;
        margin-top: auto;
        overflow: hidden;
        transition: width 0.2s;
    }

    @media (min-width: ${MOBILE_BREAKPOINT_PX}) {
        border-right: none;
        overflow-y: auto;
    }

    &.ant-layout-sider-collapsed {
        border-right: none;
        box-shadow: none;
    }

    .ant-layout-sider-zero-width-trigger {
        top: 65vh;
        border: ${themeGet('border.standard.size')} solid
            ${themeGet('border.standard.color')};
        box-shadow: ${themeGet('boxShadow.card')};
        clip-path: inset(0px -10px -10px 0px);
        background-color: ${themeGet('color.background')};
        border-left: 0;
        height: 36px;
        line-height: 36px;
        color: black;
    }
`;

export const StyledContent = styled.main`
    width: 100%;
    overflow-y: auto;
    padding: 0 ${themeGet('padding.large')};
`;
